import { MantineProvider } from '@mantine/core';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ImprintPage from './pages/ImprintPage';
import PrivacyPage from './pages/PrivacyPage';
import RootPage from './pages/RootPage';

const App = () => {
  return (
    <MantineProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RootPage />} />
          <Route path="saturday-menu" element={<RootPage />} />
          <Route path="impressum" element={<ImprintPage />} />
          <Route path="datenschutz" element={<PrivacyPage />} />
        </Routes>
      </BrowserRouter>
    </MantineProvider>
  );
};

export default App;
